import { compose } from 'redux';
import { setDisplayName, withProps } from 'recompose';

import { questionTypes } from 'sharedParts';
import { getQuestionConfigLimits } from 'sharedParts/config/blockConfig';

import RatingForm from '../rating/RatingForm';
import NumericQuestionFormField from './NumericQuestionFormField';
import withNumericRatingItemStyle from './withNumericRatingItemStyle';

const { min, max } = getQuestionConfigLimits(questionTypes.questionNumeric).itemList;

export default compose(
  withProps(({ block: { itemList } }) => ({
    ratingField: NumericQuestionFormField,
    maxCount: max,
    minCount: min,
    itemListCount: itemList.length,
  })),
  withNumericRatingItemStyle,
  setDisplayName('NumericQuestionForm'),
)(RatingForm);
